var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import dayjs from 'dayjs';
var PlanRepository = /** @class */ (function () {
    function PlanRepository(httpClient) {
        var _this = this;
        this.httpClient = httpClient;
        this.getPersonPlan = function (_a) { return __awaiter(_this, [_a], void 0, function (_b) {
            var personId = _b.personId;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.httpClient.get("/plan/person/".concat(personId), {
                            isAuthorized: true,
                        })];
                    case 1: return [2 /*return*/, _c.sent()];
                }
            });
        }); };
        this.getFamilyPlan = function (_a) { return __awaiter(_this, [_a], void 0, function (_b) {
            var familyId = _b.familyId, minDate = _b.minDate, maxDate = _b.maxDate;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.httpClient.get("/plan/family/".concat(familyId), {
                            params: {
                                minDate: dayjs(minDate).format(),
                                maxDate: dayjs(maxDate).format(),
                            },
                            isAuthorized: true,
                        })];
                    case 1: return [2 /*return*/, _c.sent()];
                }
            });
        }); };
        this.handleRecipe = function (req) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.httpClient.patch("/v2/plan/handleRecipe", {
                            body: req,
                            isAuthorized: true,
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        this.handleMeal = function (req) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.httpClient.patch("/v2/plan/handleMeal", {
                            body: req,
                            isAuthorized: true,
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        this.generatePlan = function (familyId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.httpClient.post("/plan/generateOnboardinPlan", {
                            body: { id: familyId },
                            isAuthorized: true,
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        this.generateAlternativePlanMeal = function (body) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.httpClient.post('/plan/generateAlternativePlanMeal', {
                            body: body,
                            isAuthorized: true,
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        this.getCustomMealRecipe = function (body) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.httpClient.post('/plan/getCustomMealRecipe', {
                            body: body,
                            isAuthorized: true,
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        this.findPlanRecipeAlternative = function (body) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.httpClient.post('/plan/findPlanRecipeAlternative', {
                            body: body,
                            isAuthorized: true,
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        this.saveAlternativePlanMeal = function (body) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.httpClient.post('/plan/saveAlternativeMeal', {
                            body: body,
                            isAuthorized: true,
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        this.saveSubstituteRecipe = function (body) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.httpClient.post('/plan/replaceRecipe', {
                            body: body,
                            isAuthorized: true,
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        this.getCheckNutrients = function (body) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.httpClient.post('/plan/checkNutrients', {
                            body: body,
                            isAuthorized: true,
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        this.manageGuests = function (body) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.httpClient.post('/v2/plan/guests', {
                            body: body,
                            isAuthorized: true,
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        this.generatePlanDays = function (familyId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.httpClient.post('/plan/generatePlanDays', {
                            body: { id: familyId },
                            isAuthorized: true,
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        this.generateEmptyFridgePlan = function (_a) { return __awaiter(_this, void 0, void 0, function () {
            var familyId = _a.familyId, body = __rest(_a, ["familyId"]);
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.httpClient.post('/plan/emptyFridge', {
                            body: __assign({ id: familyId }, body),
                            isAuthorized: true,
                        })];
                    case 1: return [2 /*return*/, _b.sent()];
                }
            });
        }); };
        this.saveEmptyFridgePlan = function (body) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.httpClient.post('/plan/saveEmptyFridgePlans', {
                            body: body,
                            isAuthorized: true,
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        this.emptyFridgeAlternativeMeal = function (body) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.httpClient.post('/plan/findEmptyFridgeAlternativeMeal', {
                            body: body,
                            isAuthorized: true,
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
    }
    return PlanRepository;
}());
export { PlanRepository };
